import { atom } from 'recoil';
import { RECOIL_KEY } from './key';
/**
 * 分类列表
 */
export const pageHomeCategory = atom({
    key: RECOIL_KEY.PAGE_HONE_CATEGORY,
    default: { categoryList: [], recommendBrandList: [] }
});
